import { createContext } from 'react'
import { type IMapContext } from '@/Root/Types/MapTypes'

const MapContext = createContext<IMapContext>({

})

export default MapContext
